import { useRef, useState, useCallback } from "react";

export default function BeforeAfterSlider({ item }) {
  const ref = useRef(null);
  const [pos, setPos] = useState(50);
  const dragging = useRef(false);

  const update = useCallback((clientX) => {
    const rect = ref.current?.getBoundingClientRect();
    if (!rect) return;
    const pct = ((clientX - rect.left) / rect.width) * 100;
    setPos(Math.min(97, Math.max(3, pct)));
  }, []);

  const onPointerDown = (e) => {
    dragging.current = true;
    e.currentTarget.setPointerCapture?.(e.pointerId);
    update(e.clientX);
  };
  const onPointerMove = (e) => dragging.current && update(e.clientX);
  const stop = () => (dragging.current = false);

  return (
    <figure
      ref={ref}
      className="ba-container relative aspect-[16/10] rounded-2xl overflow-hidden border border-[#1e9bff]/30 cursor-ew-resize"
      data-testid={`ba-slider-${item.id}`}
      onPointerDown={onPointerDown}
      onPointerMove={onPointerMove}
      onPointerUp={stop}
      onPointerLeave={stop}
    >
      {/* After (full background) */}
      <img src={item.after_url} alt={item.after_label} className="absolute inset-0 w-full h-full object-cover" loading="lazy" />
      {/* Before (clipped) */}
      <div className="absolute inset-0" style={{ clipPath: `inset(0 ${100 - pos}% 0 0)` }}>
        <img
          src={item.before_url}
          alt={item.before_label}
          className={`absolute inset-0 w-full h-full object-cover ${item.sample ? "ba-before-img" : ""}`}
          loading="lazy"
        />
      </div>
      {/* Divider handle */}
      <div className="absolute top-0 bottom-0 w-0.5 bg-[#1e9bff]" style={{ left: `${pos}%` }}>
        <div className="absolute top-1/2 -translate-y-1/2 -translate-x-1/2 w-10 h-10 rounded-full bg-[#1e9bff] text-black flex items-center justify-center font-bold text-sm shadow-[0_0_20px_rgba(30,155,255,0.6)]">
          ⇔
        </div>
      </div>
      <div className="absolute top-4 left-4 bg-black/80 px-3 py-1 rounded text-xs font-mono-lbl text-[#93b4d4]">{item.before_label}</div>
      <div className="absolute top-4 right-4 bg-[#1e9bff] px-3 py-1 rounded text-xs font-mono-lbl text-black font-bold">{item.after_label}</div>
      <figcaption className="absolute bottom-4 left-4 text-xs font-mono-lbl uppercase tracking-[0.14em] text-white bg-black/60 px-3 py-1.5 rounded backdrop-blur inline-block">
        {item.title}
      </figcaption>
    </figure>
  );
}
